import React, { useState } from 'react';
import {
  InputAdornment,
  Stack,
  Divider,
  TextField,
  Button,
  Box,
  Card,
} from '@mui/material';
import { AccountCircle } from '@mui/icons-material';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import api from '../../utils/functions/api';
import NotiAlert from '../../components/NotiAlert/NotiAlert';
import { useTranslation } from 'react-i18next';

function Settings() {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [openNoti, setOpenNoti] = useState(false);
  const [title, setTitle] = useState('');
  const [notiValue, setNotiValue] = useState('');

  const handleClickChangStatus = async () => {
    try {
      const newStartDate = dayjs(startDate).format('YYYY-MM-DD');
      const newEndDate = dayjs(endDate).format('YYYY-MM-DD');
      // console.log('ss', dayjs(startDate).format('YYYY-MM-DD'));
      const path = `${process.env.REACT_APP_API_URL_admin}/statement-online/write-off?startDate=${newStartDate}&endDate=${newEndDate}`;
      const { data } = await api.post(path, {});
      // console.log('data', data);
      if (data?.message === 'Update write off success.') {
        setTitle(t('app.statusUpdatedSuccessfully'));
        setNotiValue('success');
        setOpenNoti(true);
      } else {
        setTitle('ปรับสถานะไม่สำเร็จ');
        setNotiValue('cancel');
        setOpenNoti(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleNotiClose = () => {
    setOpenNoti(false);
    setTitle('');
    setNotiValue('');
  };
  return (
    <div>
      <div className="py-6 text-lg font-bold">{t('app.setting')}</div>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-10">
        <div className="">
          <Card variant="outlined" sx={{ borderRadius: 4 }}>
            <Box
              sx={{
                px: 4,
                py: 2,
                backgroundColor: 'primary.main',
                color: '#fff',
              }}
            >
              <Stack direction="row" justifyContent="" alignItems="center">
                <div className="text-lg font-semibold">{t('app.lateFeeAndDiscount')}</div>
              </Stack>
            </Box>
            <Divider />
            <Box sx={{ p: 4 }}>
              {/* <Stack direction="row" spacing={10}> */}
              <div className="flex flex-col xl:flex-row gap-2">
                <div>
                {t('app.lateFee')}
                  <div>
                    {' '}
                    <TextField
                      // label="With normal TextField"
                      size="small"
                      type="number"
                      id="fee"
                      sx={{ width: '100%' }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div>
                {t('app.discount')} 
                  <div>
                    {' '}
                    <TextField
                      size="small"
                      type="number"
                      id="discount"
                      sx={{ width: '100%' }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* </Stack> */}
            </Box>
            {/* <Divider /> */}
            <Box sx={{ px: 4, pb: 2 }}>
              <Stack
                direction="column"
                justifyContent="space-between"
                alignItems="flex-end"
              >
                <Button
                  variant="contained"
                  sx={{ color: '#fff', width: '150px' }}
                >
                  {t('app.save')  }
                </Button>
              </Stack>
            </Box>
          </Card>
        </div>

        <div className="...">
          <Card variant="outlined" sx={{ borderRadius: 4 }}>
            <Box
              sx={{
                px: 4,
                py: 2,
                backgroundColor: 'primary.main',
                color: '#fff',
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="text-lg font-semibold">
                  {t('app.registerDiscountedCompany')}
                </div>
              </Stack>
            </Box>
            <Divider />
            <Box sx={{ p: 4 }}>
              <div>
                <div>{t('navbar.taxId')}</div>
                <div className="mt-4">
                  {' '}
                  <TextField
                    // label="With normal TextField"
                    size="small"
                    id="fee"
                    sx={{ width: '100%' }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {' '}
                          <AccountCircle />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
            </Box>
            {/* <Divider /> */}
            <Box sx={{ px: 4, pb: 2 }}>
              <Stack
                direction="column"
                justifyContent="space-between"
                alignItems="flex-end"
              >
                <Button
                  variant="contained"
                  sx={{ color: '#fff', width: '150px' }}
                >
                  {t('app.add')}
                </Button>
              </Stack>
            </Box>
          </Card>
        </div>

        <div className="...">
          <Card variant="outlined" sx={{ borderRadius: 4 }}>
            <Box
              sx={{
                px: 4,
                py: 2,
                backgroundColor: 'primary.main',
                color: '#fff',
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div className="text-lg font-semibold">{t('app.adjustMonthlyStatus')}</div>
              </Stack>
            </Box>
            <Divider />
            <Box sx={{ p: 4 }}>
              <div className="flex flex-col xl:flex-row gap-2">
                <div>
                  <div>
                   {t('app.startDate')}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DatePicker']}>
                        <DatePicker
                          label="Start Date"
                          sx={{ width: '100%' }}
                          slotProps={{ textField: { size: 'small' } }}
                          value={startDate}
                          onChange={(newValue) => setStartDate(newValue)}
                          format="YYYY-MM-DD"
                          maxDate={endDate}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                </div>
                <div>
                  <div>
                   {t('app.endDate')}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['DatePicker']}>
                        <DatePicker
                          label="End Date"
                          sx={{ width: '100%' }}
                          slotProps={{ textField: { size: 'small' } }}
                          value={endDate}
                          onChange={(newValue) => setEndDate(newValue)}
                          format="YYYY-MM-DD"
                          minDate={startDate}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </div>
                </div>
              </div>
            </Box>
            {/* <Divider /> */}
            <Box sx={{ px: 4, pb: 2 }}>
              <Stack
                direction="column"
                justifyContent="space-between"
                alignItems="flex-end"
              >
                <Button
                  variant="contained"
                  sx={{ color: '#fff', width: '150px' }}
                  onClick={handleClickChangStatus}
                >
                  {t('app.changeStatus')}
                </Button>
              </Stack>
            </Box>
          </Card>
        </div>
      </div>
      <NotiAlert
        open={openNoti}
        setOpe={setOpenNoti}
        title={title}
        onButtonClick={handleNotiClose}
        value={notiValue}
      />
    </div>
  );
}

export default Settings;
